import React from "react";

import { IgRadio } from "@intelligems/ig-theme/IgRadio";
import {
  ChannelType,
  ConversionStageReachedType,
  DeviceType,
  VisitorType,
} from "@intelligems/ig-types/schemas/analytics/base";
import { getConversionStageReachedList } from "@src/components/AudienceFilters/utils";
import Stack from "@mui/material/Stack";

interface ConversionStageReachedFilterProps {
  conversionStageReached: ConversionStageReachedType;
  hasCheckoutBlocks: boolean;
  hasOnsiteUpsell: boolean;
  hasTestPostPurchase: boolean;
  onStringFilterChange: (
    newValue:
      | DeviceType
      | VisitorType
      | ChannelType
      | ConversionStageReachedType,
    filterKey:
      | "deviceType"
      | "channelType"
      | "visitorType"
      | "reachedCheckoutStage"
  ) => void;
}

export const ConversionStageReachedFilter = ({
  conversionStageReached,
  hasCheckoutBlocks,
  hasOnsiteUpsell,
  hasTestPostPurchase,
  onStringFilterChange,
}: ConversionStageReachedFilterProps) => {
  const selectedRadio = (selectedVisitorType: string | undefined): boolean => {
    if (!conversionStageReached) {
      return false;
    }
    return conversionStageReached === selectedVisitorType;
  };

  return (
    <Stack>
      {getConversionStageReachedList({
        hasCheckoutBlocks,
        hasOnsiteUpsell,
        hasTestPostPurchase,
      }).map((conversionStage) => (
        <IgRadio
          key={conversionStage.key}
          onClick={() =>
            onStringFilterChange(conversionStage.key, "reachedCheckoutStage")
          }
          name={`conversion-stage-radio-${conversionStage.key}`}
          label={conversionStage.label}
          checked={selectedRadio(conversionStage.key)}
        />
      ))}
    </Stack>
  );
};
